export default __webpack_public_path__ + "assets/images/ms-97763a7ea19fe8b87b047132bb0ea604.ico";